import { Box, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ROUTES } from 'routing';
import { ProductFilterEnum } from 'shared/constants';
import { useCurrentTab } from 'shared/hooks';
import UseDynamicUrl from 'shared/hooks/useDynamicUrl';

export function ProductFilters() {
    const currentTab = useCurrentTab({
        orderedTabList: [ProductFilterEnum.CATALOG, ProductFilterEnum.EXCLUSIVE, ProductFilterEnum.PRIVATE],
    });
    const [activeTab, setActiveTab] = useState(currentTab);

    const tabChange = useCallback((event, value: string) => {
        setActiveTab(value);
    }, []);

    const exclusivePath = UseDynamicUrl({ route: ROUTES.addProductsExclusive });
    const catalogPath = UseDynamicUrl({ route: ROUTES.addProductsCatalog });
    const privatePath = UseDynamicUrl({ route: ROUTES.addProductsPrivate });

    useEffect(() => {
        if (activeTab !== currentTab) {
            setActiveTab(currentTab);
        }
    }, [activeTab, currentTab]);

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
                value={activeTab}
                onChange={tabChange}
                textColor='secondary'
                indicatorColor='secondary'
                aria-label='customer details'
            >
                <Tab value={ProductFilterEnum.CATALOG} label={ProductFilterEnum.CATALOG} component={ReactRouterLink} to={catalogPath.path} />
                <Tab value={ProductFilterEnum.EXCLUSIVE} label={ProductFilterEnum.EXCLUSIVE} component={ReactRouterLink} to={exclusivePath.path} />
                <Tab value={ProductFilterEnum.PRIVATE} label={ProductFilterEnum.PRIVATE} component={ReactRouterLink} to={privatePath.path} />
            </Tabs>
        </Box>
    );
}
